import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { html, TemplateResult, nothing } from 'lit';
import { runInAction } from 'mobx';
import { TefComs } from '@mfe-4cs/types/typings';
import comsStore from '@mfe-4cs/state/ComsStore';

type KeysOfRef = keyof Omit<TefComs.Reference, 'state'>;

export function referenceItemTemplate(this: TefComs4csMicroFrontend, ref: TefComs.Reference): TemplateResult {
  const refVal = ref;

  const isFormDisabled = refVal.state !== 'inEdit';

  const isButtonDisabled = () => !(refVal.id && refVal.source && ref.type);

  const onChange = (e: { target: HTMLInputElement }) => {
    const name = e.target.name as KeysOfRef || undefined;
    if (name) {
      refVal[name] = e.target.value;
    }
  };

  const onDelete = (e: Event) => {
    e.preventDefault();
    runInAction(() => {
      comsStore.references = comsStore.references.filter((r) => r.id !== refVal.id);
    });
  };

  const onStartEdit = (e: Event) => {
    e.preventDefault();
    runInAction(() => {
      comsStore.references = comsStore.references.map(
        (r) => (r.id === refVal.id ? { ...r, state: 'inEdit' } : { ...r }),
      );
    });
  };

  const onSubmit = (e: Event & { target: HTMLFormElement }) => {
    e.preventDefault();
    if (refVal.id) {
      runInAction(() => {
        comsStore.references = comsStore.references.filter((r) => r.id !== refVal.id);
        comsStore.references.push({ ...refVal, state: 'new' });
      });
    }
  };

  return html`
    <form @input=${onChange} @submit=${onSubmit}>
      <div class="row align-items-center u--mb-micro-l">
        <div class="col">
          <div class="form-group-select">
            <label for="type">Typ</label>
            <select name="type" ?disabled=${isFormDisabled}>
              <option value="Voice">Voice</option>
            </select>
          </div>
        </div>
        <div class="col">
          <div class="form-group-select">
            <label for="source">Quelle</label>
            <select name="source" ?disabled=${isFormDisabled}>
              <option value="CCT">CCT</option>
            </select>
          </div>
        </div>
        <div class="col">
            <div class="form-group-input">
              <label for="id">Id</label>
              <input
                name="id"
                type="text"
                .value=${refVal.id}
                ?disabled=${isFormDisabled}>
            </div>
        </div>
        <div class="col-2">
        ${ref.state === 'inEdit' ? html`
          <tef-coms-icon icon="plus" size="l" cloak @click="${onSubmit}" ?disabled=${isButtonDisabled()}>
          </tef-coms-icon>
        ` : nothing}
        ${ref.state === 'new' ? html`
          <tef-coms-icon icon="edit" size="l" cloak @click="${onStartEdit}" ?disabled=${isButtonDisabled()}>
          </tef-coms-icon>
          <tef-coms-icon icon="trash" size="l" cloak @click="${onDelete}" ?disabled=${isButtonDisabled()}>
          </tef-coms-icon>
        ` : nothing}
      </div>
      </div>
    </form>`;
}
